import { useBranding } from 'contexts/BrandingContext';
import { Box } from '@mui/material';

// ==============================|| LOGO - ICON ||============================== //

export default function LogoIcon() {
  const { branding, loading } = useBranding();

  // Construct the icon URL - use API base URL + branding path
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';
  const baseUrl = apiUrl.replace('/api', '');

  // Use branding path if available, otherwise use default
  const iconPath = branding?.assets?.logo_icon_path || '/branding/logo-icon.svg';
  const iconUrl = `${baseUrl}${iconPath}`;
  const companyName = branding?.company?.name;

  // Show minimal loading state
  if (loading) {
    return <Box sx={{ width: 32, height: 32 }} />;
  }

  return (
    <Box
      component="img"
      src={iconUrl}
      alt={`${companyName} Icon`}
      sx={{
        height: '32px',
        width: '32px',
        objectFit: 'contain'
      }}
      onError={(e) => {
        // On error, hide the icon
        e.target.style.display = 'none';
      }}
    />
  );
}
